import { types, getEnv, flow } from 'mobx-state-tree';
import _ from 'lodash';

import StatefulStore from '../models/StatefulStore';
import CampaignCode from '../models/CampaignCode';

const CampaignCodeStore = StatefulStore.named('CampaignCodeStore')
  .props({
    activeCodes: types.optional(types.array(CampaignCode), [])
  })
  .views((self) => ({
    get campaignCodesArray() {
      return Array.from(self.activeCodes, ([key, value]) => value);
    }
  }))
  .actions((self) => {
    return {
      setup: function(activeCodes) {
        self.activeCodes = _.keyBy(activeCodes, 'id');
        self.setLoading(false);
      },
      loadActiveCodes: flow(function* getActiveCodes() {
        self.setLoading(true);

        try {
          self.activeCodes = yield getEnv(self).apiWrapper.request(
            `campaign-codes`,
            {},
            { active_section: null }
          );
        } catch (error) {
          self.setError(error);
          throw error;
        }

        self.setLoading(false);
      }),
      setCode: flow(function* setCode(campaignCode) {
        yield getEnv(self)
          .apiWrapper.apiAxios()
          .post(`campaign-codes/set`, { campaignCode });

        yield self.loadActiveCodes();
      }),
      unsetCode: flow(function* unsetCode() {
        yield getEnv(self)
          .apiWrapper.apiAxios()
          .post(`campaign-codes/unset`);

        yield self.loadActiveCodes();
      })
    };
  });

export default CampaignCodeStore;



// WEBPACK FOOTER //
// ./src/store/CampaignCodeStore.js